module.exports = __webpack_public_path__ + "img/suspend.d1899f9b.svg";